import { useState, useEffect } from "react";

export const useMediaQuery = (query) => {
  const [isMediaQueryMatchSize, setIsMediaQueryMatchSize] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);

    const handleChange = (e) => setIsMediaQueryMatchSize(e.matches);

    setIsMediaQueryMatchSize(mediaQuery.matches);

    mediaQuery.addEventListener("change", handleChange);

    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  return isMediaQueryMatchSize;
};
